import React, { useEffect, useRef } from "react";
import "./DotsBanner.css";

export default function DotsBanner({
  imageSrc,
  title,
  text,
  cta,
  minHeight = 520
}) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const section = canvas.parentElement;
    const ctx = canvas.getContext("2d", { alpha: true });
    const ratio = Math.max(1, window.devicePixelRatio || 1);

    // paramètres points
    const spacing = 10, radius = 2, baseOpacity = 0.22, maxBoost = 0.55;
    const speed = 100, sigma = 130, vertical = true;

    let points = [], cssW = 0, cssH = 0, rafId = 0;

    const setSize = () => {
      const w = section.clientWidth || 0;
      const h = section.clientHeight || 0;

      canvas.style.width = w + "px";
      canvas.style.height = h + "px";
      canvas.width = Math.round(w * ratio);
      canvas.height = Math.round(h * ratio);
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);

      cssW = w; cssH = h;

      points = [];
      for (let y = 0; y <= cssH; y += spacing) {
        for (let x = 0; x <= cssW; x += spacing) {
          points.push({ x, y });
        }
      }
    };

    const waveBoostAt = (p, t) => {
      const len = vertical ? cssH : cssW;
      if (len <= 0) return 0;
      const phase = (t * speed) / len;
      const crest = (len / 2) * (1 - Math.cos(2 * Math.PI * phase));
      const coord = vertical ? p.y : p.x;
      const d = coord - crest;
      const env = Math.exp(-(d * d) / (2 * sigma * sigma));
      return maxBoost * env;
    };

    const draw = (t) => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (const p of points) {
        let o = baseOpacity + waveBoostAt(p, t);
        if (o > 0.9) o = 0.9;
        ctx.beginPath();
        ctx.arc(p.x, p.y, radius, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${o})`;
        ctx.fill();
      }
    };

    const t0 = performance.now();
    const loop = () => {
      draw((performance.now() - t0) / 1000);
      rafId = requestAnimationFrame(loop);
    };

    setSize();
    rafId = requestAnimationFrame(loop);

    // ResizeObserver pour suivre la vraie hauteur de la section
    const ro = new ResizeObserver(() => setSize());
    ro.observe(section);

    window.addEventListener("resize", setSize);

    return () => {
      window.removeEventListener("resize", setSize);
      ro.disconnect();
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <section className="db-full" style={{ minHeight }}>
      <canvas ref={canvasRef} className="db-bg" />

      <div className="db-center">
        {imageSrc && <img className="db-img" src={imageSrc} alt="" loading="lazy" />}
        <div className="db-card">
          {title && <h2 className="db-title">{title}</h2>}
          {text && <p className="db-text">{text}</p>}
          {cta && <button className="db-btn">{cta}</button>}
        </div>
      </div>
    </section>
  );
}
